module.exports = __webpack_public_path__ + "static/media/slider-thumb-hydrostat.3226294d.png";